<div class="container-flud">
    <div class="row">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <div class="row">
        <div class="col-6">
            <mat-form-field>
                <mat-select placeholder="Outing" [(ngModel)]="selectedOuting" 
                    (selectionChange)="onOutingSelection()" [compareWith]="compareObjects">
                    <mat-option *ngFor="let outing of outings" [value]="outing">{{outing?.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-2">
            <mat-form-field *ngIf="selectedOuting">
                <mat-select placeholder="Start Date" [(ngModel)]="selectedIteration"
                    (selectionChange)="onIterationSelection()" [compareWith]="compareObjects">
                    <mat-option *ngFor="let iteration of selectedOuting.iterations"
                        [value]="iteration">{{iteration?.startDate | date: 'yyyy'}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>